import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

const display = (v, fallback = "0") =>
  v !== undefined && v !== null && v !== "" ? v : fallback;

const Cell = ({ value, status = false, fallback = "0", className = "list-item", width }) => (
  <td width={width} className={status ? "list-item-red" : className} title={display(value, fallback)}>
    {display(value, fallback)}
  </td>
);

Cell.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  status: PropTypes.bool,
  fallback: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
  width: PropTypes.string,
};

export const HealthListItem = ({ item }) => {
  const {
    deviceId,
    vehicleId,
    health,
    distance_status,
    distance,
    frequency_percentage_status,
    percentage,
    avg_delay_status,
    avgDelay,
    delayPacketCount,
    point_status,
    points,
    futureDatePoints,
    futureDatePointsStatus,
    pastDatePoints,
    pastDatePointsStatus,
    ignONCount,
    ignONCountStatus,
    powerOnCount,
    powerOnCountStatus,
    delay90thPercentile,
    delay90thPercentileStatus,
  } = item;

  const isHealthy = health === true;

  return (
    <tr key={deviceId} className="gradeA odd cursor-pointer" role="row">
      <td width="10%" className="list-item" title={vehicleId}>
        {display(vehicleId, "")}
      </td>

      <td width="13%" title={deviceId ?? "NA"}>
        {deviceId ?? "NA"}
      </td>

      <td width="5%">
        <span>
          <button
            className={classNames({
              "red-class": !isHealthy,
              "green-class": isHealthy,
              "transparent-btn": true,
            })}
          >
            <i className="fa fa-circle" aria-hidden="true"></i>
          </button>
        </span>
      </td>

      <Cell value={distance} status={distance_status} fallback={distance} />
      <Cell value={percentage} status={frequency_percentage_status} fallback={percentage} />
      <Cell value={avgDelay} status={avg_delay_status} fallback={avgDelay} />
      <td className="list-item" title={display(delayPacketCount)}>
        {display(delayPacketCount)}
      </td>
      <Cell value={points} status={point_status} fallback={points} />
      <Cell value={futureDatePoints} status={futureDatePointsStatus} />
      <Cell value={pastDatePoints} status={pastDatePointsStatus} />
      <Cell value={ignONCount} status={ignONCountStatus} />
      <Cell value={powerOnCount} status={powerOnCountStatus} />
      <Cell value={delay90thPercentile} status={delay90thPercentileStatus} fallback={delay90thPercentile} />
    </tr>
  );
};

HealthListItem.propTypes = {
  item: PropTypes.shape({
    deviceId: PropTypes.string,
    vehicleId: PropTypes.string,
    health: PropTypes.bool,
    distance_status: PropTypes.bool,
    distance: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    frequency_percentage_status: PropTypes.bool,
    percentage: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    avg_delay_status: PropTypes.bool,
    avgDelay: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    delayPacketCount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    point_status: PropTypes.bool,
    points: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    futureDatePoints: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    futureDatePointsStatus: PropTypes.bool,
    pastDatePoints: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    pastDatePointsStatus: PropTypes.bool,
    ignONCount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    ignONCountStatus: PropTypes.bool,
    ignOffCount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    ignOffCountStatus: PropTypes.bool,
    delay90thPercentile: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    delay90thPercentileStatus: PropTypes.bool,
    powerOnCount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    powerOnCountStatus: PropTypes.bool,
    powerOffCount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    powerOffCountStatus: PropTypes.bool,
  }).isRequired,
};
